import React from 'react';
import { CONTACT_EMAIL } from '../lib/constants';

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold mb-3 text-slate-800">{title}</h2>
    <p className="text-slate-600 leading-relaxed">{children}</p>
  </section>
);

const PrivacyPage: React.FC = () => (
  <div className="bg-slate-100 min-h-screen py-12 px-6">
    <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12">
      <h1 className="text-3xl md:text-4xl font-bold mb-2 text-slate-900">Privacy Policy</h1>
      <p className="text-slate-500 mb-10">Your privacy matters.</p>

      <Section title="What Data We Collect">
        This website is an informational site only. We do not collect, store, or process 
        any personal data. There are no user accounts, registration forms, or customer 
        databases on this website.
      </Section>

      <Section title="Purchases">
        All purchases are made through Etsy. When you buy a Megadish product, your 
        transaction is handled entirely by Etsy, and their privacy policy applies to 
        that purchase. We receive only the information necessary to fulfil your order 
        (shipping address and order details). We do not store payment information.
      </Section>

      <Section title="Megadish Products">
        Megadish devices do not collect, transmit, or store any personal data. 
        The device operates locally to extend your WiFi connection. No usage data, 
        browsing history, or personal information is collected by the device or 
        sent to us.
      </Section>

      <Section title="Cookies">
        This website does not use cookies or tracking technologies.
      </Section>

      <Section title="Contact">
        If you have any questions about this privacy policy, please contact us 
        at {CONTACT_EMAIL}.
      </Section>

      <p className="text-sm text-slate-500 pt-6 border-t border-slate-200">
        Last updated: May 2026
      </p>
    </div>
  </div>
);

export default PrivacyPage;
